'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import QuickShipFilter from 'components/essentials/ConsumerFilters/components/QuickShipFilter';
import useAdvancedSearchContext from 'components/consumer/consumer-search/advanced-search-next/hooks/useAdvancedSearchContext';
import WidthRangeFilter from 'components/consumer/consumer-search/advanced-search-next/components/WidthRangeFilter';
import ClearAllFiltersButtonComponent from 'components/consumer/consumer-search/advanced-search-next/components/ClearAllFiltersButton';
import ProductTypeRefinementList from 'components/consumer/consumer-search/advanced-search-next/components/AdvancedSearchSidebar/components/ProductTypeRefinementList';
import CategorySearchBox from './CategorySearchBox';
const CategoryAlgoliaSidebar = t0 => {
  const $ = _c(11);
  const {
    pageName
  } = t0;
  const {
    isReadyToShipActive,
    handleToggleReadyToShip
  } = useAdvancedSearchContext();
  let t1;
  if ($[0] !== pageName) {
    t1 = <CategorySearchBox pageName={pageName} />;
    $[0] = pageName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4"><ClearAllFiltersButtonComponent /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleToggleReadyToShip || $[4] !== isReadyToShipActive) {
    t3 = <div className="mt-4"><QuickShipFilter isChecked={isReadyToShipActive} onChange={handleToggleReadyToShip} minHeight={false} withLocation={true} /></div>;
    $[3] = handleToggleReadyToShip;
    $[4] = isReadyToShipActive;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mt-4"><WidthRangeFilter showTitle={true} /></div>;
    t5 = <div><h3 className="text-base font-bold mb-2 mt-4">Product Type</h3><ProductTypeRefinementList /></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t1 || $[9] !== t3) {
    t6 = <>{t1}{t2}{t3}{t4}{t5}</>;
    $[8] = t1;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
CategoryAlgoliaSidebar.propTypes = {
  pageName: PropTypes.string
};
export default CategoryAlgoliaSidebar;